// extracted by mini-css-extract-plugin
export default {"linkButton":"LegalLinks_linkButton__vkE99"};